/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19.41"
        height="19.42"
        viewBox="0 0 19.41 19.42"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m0 15.14 4.27 4.28 8.07-8.05 2.93-.68 4.14-4.2L12.91 0 8.8 4.16l-.7 2.9-8 8ZM12.92 1.42 18 6.5l-.84.85-5.08-5.08Zm-4 6.22.7-2.91 1.7-1.72 5.08 5.08-1.7 1.72-2.92.68-7.57 7.54-2.86-2.86Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'FlashlightIcon';

export default Icon;
